module.exports = __webpack_public_path__ + "static/img/短视频-纯剪辑短视频.9803eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/短视频-纯剪辑短视频.png
// module id = 5Vv1
// module chunks = 1